import React from "react";
import Banner from "../components/registry/banner";
import CardCarousel from "../components/registry/card-carousel";
import Appreciation from "../components/registry/appreciation";
import GalFooter from "../components/gallery/gallery-footer";

function GiftRegistry() {
  return (
    <>
      <Banner />
      <CardCarousel />
      <Appreciation />
      <GalFooter />
    </>
  );
}
export default GiftRegistry;
